export default (options) => {
  return {
    applyHtmlTags: ['checkbox'].map(tag => tag.toLowerCase())
  }
}
